export enum AppFlavour {
    DEFAULT = 'default',
    SHIFT4 = 'shift4',
}
